import React from 'react';
import { ICurrencyRate } from 'types/currency';

// Null stands for currency api error and empty value (NOTE: hide local currency if null is given)
export const CurrencyContext = React.createContext<ICurrencyRate | null>(null);
